export default (self, data) => {
  let columnDefs = []
  columnDefs.push(
    {
      headerName: '',
      width: 30,
      field: 'rowIndex',
      hidden: true,
      suppressMovable: true,
      cellStyle: {
        textAlign: 'center',
        padding: '5px 0',
        color: '#595959',
        backgroundColor: '#f0f0f0',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: '500',
        boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)'
      }
    }
  )
  columnDefs.push(
    {
      headerName: '活动名称',
      field: 'name',
      width: 20,
      cellStyle: {
        textAlign: 'center',
      },
      style: {
        alignment: {vertical: 'bottom', horizontal: 'left'},
      },
    },
    // {
    //   headerName: '是否需要报名',
    //   field: 'apply',
    //   width: 20,
    //   cellStyle: {
    //     textAlign: 'center',
    //   },
    //   style: {
    //     alignment: {vertical: 'bottom', horizontal: 'left'},
    //   },
    // },
    {
      headerName: '状态',
      field: 'state',
      width: 20,
      cellStyle: {
        textAlign: 'center',
      },
      style: {
        alignment: {vertical: 'bottom', horizontal: 'left'},
      },
    },
    {
      headerName: '主办方',
      field: 'sponsor',
      width: 20,
      cellStyle: {
        textAlign: 'center',
      },
      style: {
        alignment: {vertical: 'bottom', horizontal: 'left'},
      },
    },
    {
      headerName: '活动时间',
      field: 'activityTime',
      width: 50,
      cellStyle: {
        textAlign: 'center',
      },
      style: {
        alignment: {vertical: 'bottom', horizontal: 'left'},
      },
    },
    {
      headerName: '参加人数',
      field: 'participateNum',
      width: 20,
      cellStyle: {
        textAlign: 'center',
      },
      style: {
        alignment: {vertical: 'bottom', horizontal: 'left'},
      },
    },
  )

  let partList = []
  let leng = 0
  if(data && data.length) {
    for (let i = 0; i < data.length ; i++) {
      let iLen = data[i]['partList'].length
      for (let j = 0; j<data.length -i -1;j++){
        let jLen = data[j]['partList'].length
        if(jLen > iLen) {
          leng = jLen
        } else {
          leng = iLen
        }
      }
    }

    data.forEach(e => {
      if (e['partList'] && e['partList'].length && e['partList'].length === leng) {
        partList = e['partList']
      }
    })
  }

  if (partList && partList.length) {
    let i = 0
    partList.forEach(e => {
      i++
      columnDefs.push(
        {
          headerName: '环节' + i,
          children: [
            {
              headerName: '环节名称',
              field: 'title_' + i,
              width: 20,
              cellStyle: {
                textAlign: 'center',
              },
              style: {
                alignment: {vertical: 'bottom', horizontal: 'left'},
              },
            },
            {
              headerName: '环节时间',
              field: 'partTime_' + i,
              width: 50,
              cellStyle: {
                textAlign: 'center',
              },
              style: {
                alignment: {vertical: 'bottom', horizontal: 'left'},
              },
            },
            {
              headerName: '环节类型',
              field: 'partType_' + i,
              width: 20,
              cellStyle: {
                textAlign: 'center',
              },
              style: {
                alignment: {vertical: 'bottom', horizontal: 'left'},
              },
            },
          ]
        }
      )
    })
  }
  return columnDefs
}
